import type { ApiClientV2Default } from 'utils/api-client/api-client.utils'

const BASE_URL = '/cabinet/joint_ventures'

export interface JointVenture {
  id: string | number
  futureCommission: number
  inviteeFirstName: string
  inviteeLastName: string
  email: string
  role: string
  permissions: string[]
  invitedAt: string
  jointVentureProductsAttributes: {
    id: string
    commission: number
    product: {
      id: number
      name: string
      form: string
      internalName: string
      active: boolean
      private: boolean
      covers: {
        cover: string
        file: {
          custom: string
          s100: string
        }
      }[]
    }
  }[]
}

export interface Params {
  page: {
    size: number
    number: number
  }
  stats: { total: 'count' }
  filter?: {
    created_at: {
      gte: string
      lte: string
    }
  }
  sort: 'id' | '-id' | 'invited_at' | '-invited_at'
  query?: string
}

export const createJointVenturesApi = ({ GET }: ApiClientV2Default) => ({
  fetchList: (data) => GET<JointVenture[]>(BASE_URL, data),
})

export type JointVenturesApi = ReturnType<typeof createJointVenturesApi>
